module.exports = __webpack_public_path__ + "static/media/40.6c042a73.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/accessoires/40.png
// module id = 409
// module chunks = 0